import React from 'react';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import SelectDropdown from 'components/base/select-dropdown';
import { PLUS_ICON } from 'assets/icons/siderbar-icons';
import useDashboardContext from 'contexts/dashboard.context';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';
import EditableInput from 'components/base/editable-input';

type VendorDetailsTabProps = {
  onVendorChange: (itemIndex: number, vendorIndex: number, selectedVendor: any) => void;
  onVendorPriceChange: (itemIndex: number, vendorIndex: number, price: string) => void;
  onAddVendor: (itemIndex: number) => void;
  onDeleteVendor: (itemIndex: number, vendorIndex: number) => void;
};

const VendorDetailsTab: React.FC<VendorDetailsTabProps> = ({
  onVendorChange,
  onVendorPriceChange,
  onAddVendor,
  onDeleteVendor
}) => {
  const { storeItemArray } = useInventoryStoreContext();
  const { formVendorsList } = useDashboardContext();
  const VENDOR_DETAILS_HEADERS = ['Item Name', 'Vendor Name', 'Price', 'Actions'];

  return (
    <Table headers={VENDOR_DETAILS_HEADERS}>
      {storeItemArray.flatMap((storeItem, itemIndex) =>
        storeItem.vendors.length === 0
          ? [
              <TableRow key={`${itemIndex}-empty`} className='hover:bg-gray-50 transition-colors'>
                <TableData className='px-2 py-2 text-sm text-gray-800'>
                  <span className='font-medium'>{storeItem.name}</span>
                </TableData>
                <TableData className='px-2 py-2 text-sm text-gray-400'>
                  <p className='border p-2 border-red-5'> No vendors added</p>
                </TableData>
                <TableData className='px-2 py-2 text-sm text-gray-400'>-</TableData>
                <TableData className='px-2 py-2 text-sm'>
                  <button
                    onClick={() => onAddVendor(itemIndex)}
                    className='text-[#0080E5] font-medium text-xs border border-[#E5E6E6] border-dashed rounded px-2 py-1 flex gap-1 items-center hover:bg-blue-50'>
                    <PLUS_ICON />
                    Add Vendor
                  </button>
                </TableData>
              </TableRow>
            ]
          : storeItem.vendors.map((vendor, vendorIndex) => (
              <TableRow
                key={`${itemIndex}-${vendorIndex}`}
                className='hover:bg-gray-50 transition-colors'>
                <TableData className='px-2 py-2 text-sm text-gray-800'>
                  <span className='font-medium'>{storeItem.name}</span>
                </TableData>

                <TableData className='px-2 py-2 text-sm text-gray-800'>
                  <div className={vendor.name ? '' : 'border border-red-5'}>
                    <SelectDropdown
                      placeholder='Select vendor'
                      value={vendor.name || 'No vendor'}
                      setValue={(selectedVendor) =>
                        onVendorChange(itemIndex, vendorIndex, selectedVendor)
                      }
                      options={formVendorsList}
                    />
                  </div>
                </TableData>

                <TableData className='px-2 py-2 text-sm text-gray-800'>
                  <EditableInput
                    isEditing
                    showError
                    type='number'
                    value={vendor.price}
                    placeholder='Enter price'
                    onChange={(e) => onVendorPriceChange(itemIndex, vendorIndex, e.target.value)}
                  />
                </TableData>

                <TableData className='px-2 py-2 text-sm'>
                  <div className='flex items-center gap-2'>
                    <button
                      onClick={() => onAddVendor(itemIndex)}
                      className='text-[#0080E5] font-medium text-xs border border-[#E5E6E6] border-dashed rounded px-2 py-1 flex gap-1 items-center hover:bg-blue-50'>
                      <PLUS_ICON />
                      Add Vendor
                    </button>

                    <div
                      className='cursor-pointer text-red-5'
                      onClick={() => onDeleteVendor(itemIndex, vendorIndex)}>
                      <DeleteIcon />
                    </div>
                  </div>
                </TableData>
              </TableRow>
            ))
      )}
    </Table>
  );
};

export default VendorDetailsTab;
